import React from 'react';
import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import './index.scss';
import ApiResponses from './ApiResponses';

function ApiDocItem({
  name,
  description,
  endpoint,
  method,
  headers,
  parameters,
  responses,
}) {
  const { t } = useTranslation();

  const renderRequiredTag = (required) => {
    if (required) {
      return <span className="required-tag --yes">Yes</span>;
    }

    return <span className="required-tag --no">No</span>;
  };

  return (
    <div className="api-document__content__api-information">
      <div className="api-name">{name}</div>
      <div className="api-description">{description}</div>
      <div className="api-endpoint">
        <div className="title">
          {t('api_page.documents.api_detail.endpoint')}
        </div>
        <div className="api-endpoint--url font-JM">
          {method} {endpoint}
        </div>
      </div>
      {headers.length > 0 && (
        <div className="api-headers">
          <div className="title">
            {t('api_page.documents.api_detail.headers')}
          </div>
          <table className="table">
            <thead className="thead-primary">
              <tr>
                <th className="parameter">
                  {t('api_page.documents.api_detail.table.parameter')}
                </th>
                <th className="required">
                  {t('api_page.documents.api_detail.table.required')}
                </th>
                <th>{t('api_page.documents.api_detail.table.description')}</th>
              </tr>
            </thead>

            <tbody>
              {headers.map((item) => (
                <tr key={uniqueId()}>
                  <td>{item.atribute}</td>
                  <td>{renderRequiredTag(item.required)}</td>
                  <td>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: `${item.description}`,
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {parameters?.length > 0 && (
        <div className="api-parameters">
          <div className="title">
            {t('api_page.documents.api_detail.parameters')}
          </div>
          <table className="table">
            <thead className="thead-primary">
              <tr>
                <th className="parameter">
                  {t('api_page.documents.api_detail.table.parameter')}
                </th>
                <th className="required">
                  {t('api_page.documents.api_detail.table.required')}
                </th>
                <th>{t('api_page.documents.api_detail.table.type')}</th>
                <th>{t('api_page.documents.api_detail.table.description')}</th>
              </tr>
            </thead>

            <tbody>
              {parameters.map((item) => (
                <tr key={uniqueId()}>
                  <td>{item.atribute}</td>
                  <td>{renderRequiredTag(item.required)}</td>
                  <td>{item.type}</td>
                  <td>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: `${item.description}`,
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {Object.keys(responses).length > 0 && (
        <div className="api-responses">
          <div className="title">
            {t('api_page.documents.api_detail.responses')}
          </div>
          <ApiResponses data={responses} />
        </div>
      )}
    </div>
  );
}

ApiDocItem.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  endpoint: PropTypes.string,
  method: PropTypes.string,
  headers: PropTypes.array,
  parameters: PropTypes.array,
  responses: PropTypes.object,
};

export default ApiDocItem;
